import { ReactElement } from 'react'
import { NavLink, Outlet } from 'react-router-dom'
import styled from 'styled-components'
import { Theme } from 'theme/theme'
import { pages } from 'navigation/pages'

export default function EinvoicingLayout(): ReactElement {
  document.title = 'E-FACTURE'

  return (
    <Wrapper>
      <Nav>
        <Title>E-FACTURE</Title>
        <NavLink to={pages.connected.eInvoicing.daily.navigate()}>Contrôle Journalier</NavLink>
        {/* <NavLink to={pages.connected.eInvoicing.weekly.navigate()}>Contrôle Hebdo</NavLink> */}
        <NavLink to={pages.connected.eInvoicing.compliance.navigate()}>Artisans compliance</NavLink>
        <NavLink to={pages.connected.eInvoicing.actions.navigate()}>Actions</NavLink>
        <NavLink to={pages.connected.eInvoicing.received.navigate()}>E-Invoices Received</NavLink>
      </Nav>
      <WrapperContent>
        <Outlet />
      </WrapperContent>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
`

const Nav = styled.nav`
  display: flex;
  flex-direction: column;
  border-right: solid 1px ${Theme.colors.greyDark};
  padding-right: 15px;
  font-size: 15px;
  gap: 20px;
  a {
    color: ${Theme.colors.blueArtizen};
    font-weight: 700;
    text-decoration: none;
  }

  a.active {
    color: ${Theme.colors.greenArtizen};
  }
`

const Title = styled.span`
  font-size: 20px;
  font-weight: 700;
  border-bottom: 2px solid ${Theme.colors.blueArtizen};
  color: ${Theme.colors.blueArtizen};
`

const WrapperContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-left: 25px;
  margin-right: 25px;
  margin-top: 15px;
`
